<script>
export default {
  name: 'LogStatus',
  props: {
    status: {
      type: [Number, String],
      default: 200,
    },
  },
  computed: {
    computedStatus() {
      const codeType = this.status.toString().charAt(0)
      switch (codeType) {
        case '2':
          return this.status + ' OK'
        case '3':
          return this.status + ' REDIRECT'
        case '5':
        case '4':
          return this.status + ' ERR'
        default:
          return this.status
      }
    },
    isError() {
      const statusDigit = this.status.toString().charAt(0)

      return statusDigit !== '2' && statusDigit !== '3'
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div
      :class="{
        [$style.status]: true,
        [$style.statusError]: isError,
      }"
    >
      {{ computedStatus }}
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  justify-content: flex-start;
}

.status {
  display: flex;
  align-items: center;
  height: rem(24px);
  padding: rem(0 10px);
  line-height: 1;
  background: #f2efef;
  border-radius: rem(12px);
}

.statusError {
  color: #f00;
  background: #fbe6d1;
}
</style>
